import React from 'react';

interface TitleFieldProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  label?: string;
  required?: boolean;
  width?: 'fit' | 'auto' | 'full' | number;
  disabled?: boolean;
  className?: string;
}

export const TitleField: React.FC<TitleFieldProps> = ({
  value,
  onChange,
  onBlur,
  placeholder = '',
  label,
  required = false,
  width = 'full',
  disabled = false,
  className = '',
}) => {
  const getWidthClass = () => {
    switch (width) {
      case 'fit':
        return 'w-fit';
      case 'auto':
        return 'w-auto';
      case 'full':
        return 'w-full';
      default:
        return typeof width === 'number' ? `w-[${width}px]` : 'w-full';
    }
  };

  const widthStyle = typeof width === 'number' ? { width: `${width}px` } : {};

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {label && (
        <label className="text-sm font-medium text-foreground">
          {label}
          {required && <span className="text-destructive ml-1">*</span>}
        </label>
      )}
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        className={`
          ${getWidthClass()}
          px-3 py-2
          h-8
          rounded
          border border-input
          bg-background
          focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent
          disabled:bg-muted disabled:cursor-not-allowed
          text-foreground
          placeholder:text-muted-foreground
          transition-all
          whitespace-nowrap
          overflow-hidden
          text-ellipsis
        `}
        style={widthStyle}
      />
    </div>
  );
};

